import { keyMirror } from '@gilbarbara/helpers';

import { Status } from 'types';

export const ActionTypes = keyMirror({
  GITHUB_GET_REPOS_REQUEST: undefined,
  GITHUB_GET_REPOS_SUCCESS: undefined,
  GITHUB_GET_REPOS_FAILURE: undefined,
  HIDE_ALERT: undefined,
  SHOW_ALERT: undefined,
  USER_LOGIN_REQUEST: undefined,
  USER_LOGIN_SUCCESS: undefined,
  USER_LOGIN_FAILURE: undefined,
  USER_LOGOUT_REQUEST: undefined,
  USER_LOGOUT_SUCCESS: undefined,
  USER_LOGOUT_FAILURE: undefined,
  SCRIM_CHOOSE_PLAYER_REQUEST: undefined,
  SCRIM_REMOVE_PLAYER_FROM_TEAM_REQUEST: undefined,
  SCRIM_MATCH_START_DATE_REQUEST: undefined,
  SCRIM_MATCH_START_TIME_REQUEST: undefined,
  SCRIM_MATCH_TYPE_REQUEST: undefined,
  SCRIM_CHOOSE_TEAM_OPPONENT_REQUEST: undefined,
  CREATE_TEAM_CHOOSE_PLAYER_REQUEST: undefined,
  CREATE_TEAM_REMOVE_PLAYER_REQUEST: undefined,
  CREATE_TEAM_CHOOSE_GAME_REQUEST: undefined,
  CREATE_TEAM_JOIN_TEAM_REQUEST: undefined,
  CREATE_TEAM_ADD_LOGO_REQUEST: undefined,
  CREATE_TEAM_WA_FOR_MEMBER_REQUEST: undefined,
  CREATE_TEAM_WA_FOR_OPPONENT_REQUEST: undefined,
  CREATE_TEAM_DISCORD_FOR_MEMBER_REQUEST: undefined,
  CREATE_TEAM_NAME_REQUEST: undefined,
  CREATE_TEAM_REMOVE_DRAFT_REQUEST: undefined,
});

export const STATUS: Status = {
  IDLE: 'idle',
  RUNNING: 'running',
  READY: 'ready',
  SUCCESS: 'success',
  ERROR: 'error',
};
